'use client';
import { useEffect, useState } from 'react';
import { Box, IconButton, Badge } from '@mui/material';
import { useRouter } from 'next/navigation';
import { DirectMessage } from '@/public/icon';
import chatService from '@/app/service/chatService';
import NotificationsAlert from '@/app/components/MUI/NotificationsAlert';

// 상단바 우측 액션 — DM(안 읽음 점) + 알림.
//
// 홈에 있던 것을 그대로 뽑아 공용으로 둔다. 마이채널 "계정 및 설정" 헤더에도 같은 두
// 아이콘이 있어야 해서(시안 4088:1655), 화면마다 따로 만들면 안 읽음 뱃지 로직이 갈라진다.

const NavBarActions = ({ userId }: { userId?: number | string | null }) => {
    const router = useRouter();
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        const fetchUnreadCount = async () => {
            try {
                const conversations = await chatService.getConversations();
                const totalUnread = conversations.reduce((sum, conv) => sum + (conv.unread_count || 0), 0);
                setUnreadCount(totalUnread);
            } catch (error) {
                console.error('Error fetching unread count:', error);
            }
        };

        if (userId) {
            fetchUnreadCount();

            // 다른 탭·앱에서 읽고 돌아왔을 때 숫자가 남아 있지 않게 한다.
            const handleVisibilityChange = () => {
                if (document.visibilityState === 'visible') {
                    fetchUnreadCount();
                }
            };

            document.addEventListener('visibilitychange', handleVisibilityChange);
            return () => {
                document.removeEventListener('visibilitychange', handleVisibilityChange);
            };
        }
    }, [userId]);

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton onClick={() => router.push('/chat')} sx={{ p: 0.5 }}>
                <Badge
                    badgeContent={
                        unreadCount > 0 ? (
                            <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="3" cy="3" r="3" fill="#FF2164" />
                            </svg>
                        ) : null
                    }
                    sx={{
                        '& .MuiBadge-badge': {
                            right: '1px',
                            top: '6px',
                            minWidth: '6px',
                            height: '6px',
                            padding: 0,
                            borderRadius: '50%',
                        },
                    }}
                >
                    <DirectMessage width="24" height="24" />
                </Badge>
            </IconButton>
            <NotificationsAlert sx={{ marginRight: -2 }} />
        </Box>
    );
};

export default NavBarActions;
